import React from 'react';

const BuyMeCoffee = () => {
  return (
    <div className="support-buttons">
      <a 
        href="https://buymeacoffee.com/jeffalvin4l" 
        target="_blank" 
        rel="noopener noreferrer"
        className="coffee-btn"
      >
        <span className="coffee-icon">☕</span>
        <span>Buy me a coffee</span>
      </a>
      
      <a 
        href="https://www.paypal.com/paypalme/Jeffjoves420" 
        target="_blank" 
        rel="noopener noreferrer"
        className="paypal-btn"
      >
        <span className="paypal-icon">🅿️</span>
        <span>PayPal</span>
      </a>
    </div>
  );
};

export default BuyMeCoffee;